module.exports = __webpack_public_path__ + "static/media/token-wbnb.7c6a113f.svg";